import React, { useState } from 'react';

import { Grid } from '@material-ui/core';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import useDateInputStyles from './styles';

import { ReactComponent as CalendarIcon } from 'assets/images/at_calendar.svg';

import { Input } from 'ui/FormInputs';
import CalendarModal from './Calendar';

const DateInputField = ({
    label,
    name,
    value,
    placeholder,
    onChange,
    error,
    helperText,
    customStyle,
    disabled = false,
}) => {
    const styles = useDateInputStyles();
    const [open, setOpen] = useState(false);

    return (
        <>
            <Grid>
                <Input
                    variant="outlined"
                    label={label}
                    labelClass={styles.inputLabel}
                    value={value}
                    name={name}
                    className={clsx(styles.inputField, customStyle)}
                    placeholder={placeholder}
                    onClick={() => !disabled && setOpen(true)}
                    EndAdornmentIcon={CalendarIcon}
                    error={error}
                    helperText={helperText}
                    disabled={disabled}
                />
            </Grid>
            <CalendarModal
                open={open}
                setOpen={setOpen}
                label={label}
                value={value}
                name={name}
                placeholder="MM-DD-YYYY"
                onChange={onChange}
            />
        </>
    );
};

DateInputField.propTypes = {
    label: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.string,
    placeholder: PropTypes.string,
    onChange: PropTypes.func,
    error: PropTypes.bool,
    helperText: PropTypes.string,
    customStyle: PropTypes.string,
    disabled: PropTypes.bool,
};

export default DateInputField;
